export const isNotANumber = (value) => (Number.isNaN(value) || typeof value !== 'number');
